import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export default function useQueryParamsUpdater() {
  const history = useHistory();

  const updateQueryParams = useCallback(
    (newParams) => {
      const { pathname, search } = history.location;
      const existingParams = Object.fromEntries(new URLSearchParams(search));
      const nextParams = {
        ...existingParams,
      };

      Object.entries(newParams || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          delete nextParams[key];
          return;
        }
        nextParams[key] = String(value);
      });

      const nextSearch = new URLSearchParams(nextParams).toString();
      const nextUrl = nextSearch ? `${pathname}?${nextSearch}` : pathname;
      const currentUrl = `${pathname}${search}`;

      if (nextUrl === currentUrl) {
        return;
      }

      history.replace(nextUrl);
    },
    [history],
  );

  const deleteQueryParam = useCallback(
    (param) => {
      const { pathname, search } = history.location;
      const existingParams = Object.fromEntries(new URLSearchParams(search));
      if (!(param in existingParams)) {
        return;
      }

      delete existingParams[param];

      const nextSearch = new URLSearchParams(existingParams).toString();
      const nextUrl = nextSearch ? `${pathname}?${nextSearch}` : pathname;
      const currentUrl = `${pathname}${search}`;

      if (nextUrl === currentUrl) {
        return;
      }

      history.replace(nextUrl);
    },
    [history],
  );

  return { updateQueryParams, deleteQueryParam };
}
